import './Slider.css';

function Slider() {
  return(
    <div className='padreSector'>
      <div id="titleLista">
        <h1>Clientes Satisfechos</h1>
      </div>
      <div className="padreLista">
        <ul className="padreOpiniones">
          <li id='opinion1'><p>Catalina</p><p className='opinion'>La verdad que el servicio es excelente. Desde que hicieron mi pagina web, prácticamente ni me ocupo de cobrar por mis encargos</p></li>
          <li id='opinion2'><p>Federico</p><p className='opinion'>Como abogado se me facilito mucho el trabajo,  ya que no tengo que atender a los clientes a cada rato para organizar mis consultas. Tengo un bot que lo hace por mi</p></li>
        </ul>
      </div>
    </div>
  );
}

export default Slider;